<template>
  <div class="content">
    <h1 class="has-text-centered">
      Search Results
    </h1>
    <div
      v-if="searching"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="!users.length && !searching"
      class="has-text-centered"
      style="margin-top: 5rem"
    >
      <span class="has-text-info is-size-5">We couldn't find any results matching your search criteria</span>
    </div>
    <div
      v-if="users.length && !searching"
      class="columns"
    >
      <div class="column is-12">
        <div
          v-for="(player, index) in paginatedUsers"
          class="box is-inline-block winner-card"
        >
          <div class="media-left is-pulled-left">
            <img
              v-if="!player.photo"
              src="/images/profile.png"
              alt="Image"
            >
            <img
              v-if="player.photo"
              :src="player.photo"
              alt="Image"
            >
          </div>
          <div class="columns is-flex">
            <div class="column is-12">
              <div class="card-content-left">
                <router-link :to="{path: `/players/${player.ahlid}`}">
                  <strong>{{ player.ahlid }}</strong>
                </router-link>
              </div>
              <div class="card-content-left">
                <router-link :to="{path: `/players/${player.ahlid}`}">
                  <strong>{{ player.name }}</strong>
                </router-link>
              </div>
              <div class="action-buttons">
                <div class="control is-grouped">
                  <router-link
                    :to="{path: `/players/${player.ahlid}`}"
                    class="button is-small tooltip"
                    data-tooltip="View Player Page"
                  >
                    <i class="far fa-address-card-o" />
                  </router-link>
                  <a
                    class="button is-small tooltip"
                    data-tooltip="Send Friend Request"
                    @click="addFriend(player.ahlid)"
                  ><i class="far fa-user-plus" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination is-flex">
          <a
            class="pagination-previous"
            :disabled="pagination < 20"
            @click="paginateMinus()"
          >Previous</a>
          <a
            class="pagination-next is-pulled-right"
            :disabled="(pagination + 20) > users.length || users.length <= 10"
            @click="paginatePlus()"
          >Next</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'SearchResults',
    components: {
    },
    props: ['token', 'user'],
    data() {
      return {
        users: '',
        searching: true,
        searchCriteria: '',
        pagination: 0
      }
    },
    computed: {
      paginatedUsers() {
        return this.users.slice(this.pagination, this.pagination + 20)
      }
    },
    watch: {
      '$route'(to, from) {
        this.searchCriteria = to.query.search
        this.searching = true
        this.search()
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      this.pagination = 0
      this.searchCriteria = this.$route.query.search
      this.search()
    },
    methods: {
      search() {
        this.$axios({
          method: 'POST',
          url: `general/membersearch`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            'criteria': this.searchCriteria
          }
        })
          .then((res) => {
            this.users = res.data.users
            this.searching = false
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      addFriend(id) {
        this.$axios({
          method: 'POST',
          url: `member/addfriend/${this.token}/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: res.data.message
              })
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error.response.data.message
              })
          })
      },
      paginatePlus() {
        if (this.users.length > (this.pagination + 20)) {
          this.pagination += 20
        }
      },
      paginateMinus() {
        if (this.pagination >= 20) {
          this.pagination -= 20
        }
      }
    }
  }
</script>
